$(document).ready(function() {
  $(".custom_action_search_icons").click(function() {
  	$('.header-layout--between').toggleClass('white_bg1');
  });

  $(".custom_action_search_icons").click(function() {
  	$('.header-layout--between').toggleClass('white_bg');
    $('.dropdown-style-vertical').addClass('white_bg');

  });

  $(".search-overlay__close").click(function() {
    $('.header-layout--between').removeClass('white_bg1');
  });

  $(".custom_action_search_icons").click(function() {
  	$("#header").css("background", "white !important")
  });

  $('.navbar-item[data-navlink-handle="catering"]>a').attr("target","_blank");
});

$(document).on("scroll", function() {

  	// when the user srolls the page, execute the first left side bar function work
// 	var winScroll = document.body.scrollTop || document.documentElement.scrollTop;
//     var height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
//     var scrolled = (winScroll / height) * 800;
//     if (scrolled <= 100) {
// 		document.getElementById("myBar").style.width = scrolled + "%";
//     	document.getElementById("myBar1").style.width = scrolled + "%";
//     }



//   	var scrollTop = $(window).scrollTop();
//   	var elementOffset = $(".custom_leftanimation_righttext_section2").offset().top;
//   	var distance = elementOffset - scrollTop;
//   	if( distance <= 820) {
//     	var winScroll1 = document.body.scrollTop || document.documentElement.scrollTop;
//         var height1 = document.documentElement.scrollHeight - document.documentElement.clientHeight;
//         var scrolled1 = (winScroll1 / height1) * 770;
//         var scrolled2 = scrolled1 - 533.245;

//         if (scrolled2 <= 100) {
// 			document.getElementById("myBar2").style.width = scrolled2 + "%";
//         	document.getElementById("myBar3").style.width = scrolled2 + "%";
//         }
//     }



//   	let image = document.getElementById("rotate_reload");
//     image.style.transform = "rotate(" + window.pageYOffset/5 + "deg)";

//This is 60 number automatically increasement style code.

//     var scrollTop = $(window).scrollTop();
//     var elementOffset1 = $(".custom_right_bg_section_important").offset().top;
//     var distance1 = elementOffset1 - scrollTop;
//     var step = 8;

//     for(i=1; i<=61; i++){
//       if( distance1 <= (500-(i*step))) {
//         $("#number_increase_id").text(i-1);
//       }
//     }



});

$(window).on("load",function() {
  $(window).scroll(function() {
    var windowBottom = $(this).scrollTop() + $(this).innerHeight();
    $(".fade").each(function() {
      /* Check the location of each desired element */
      var objectBottom = $(this).offset().top + $(this).outerHeight();

      /* If the element is completely within bounds of the window, fade it in */
      if (objectBottom < windowBottom) { //object comes into view (scrolling down)
        if ($(this).css("opacity")==0) {$(this).fadeTo(500,1);}
      } else { //object goes out of view (scrolling up)
        if ($(this).css("opacity")==1) {$(this).fadeTo(500,0);}
      }
    });
  }).scroll(); //invoke scroll-handler on page-load
});

$(document).ready(function() {
  $('.half-image-section a:not(.landing-page-button)').on('click', function() {
      var $addToCartForm = $(this).next('form');
      Shopify.theme.jsAjaxCart.addToCart($addToCartForm);
    /*
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: 1,
        id: 41708280053967
      },
      dataType: 'json',
      success: function (data) {
        setTimeout(function() {

        	$('.header-cart > a').trigger('click');
        }, 500);
      }
 });*/
    return false;
  });
});

// avocado oil page

$(document).ready(function() {
  $('.half-image-section:not(.landing-page-half-image)').each(function() {
    var position = $(this).data('position');
    var order = $(this).data('order');

    var winHeight = $(window).height();

    var calculatedImageWidth = 4 * winHeight / 3;

    var halfWindow = $(window).width() / 2;

    var maxRight = Math.floor(halfWindow - calculatedImageWidth);


    var quarterWindow = $(window).width() / 4;
    var eighthWindow = $(window).width() / 8;
    var sixteenWindow = $(window).width() / 16;
    var thirtyWindow = $(window).width() / 32;

    if(order == 1) {
      if(position == 'left0') {
        $(this).find('.half-image-absolute').css('background-position', 'left center');
      }
      if(position == 'left25') {
        $(this).find('.half-image-absolute').css('background-position', Math.floor(maxRight/4)+'px center');
      }
      if(position == 'center') {
        $(this).find('.half-image-absolute').css('background-position', Math.floor(maxRight/2)+'px center');
      }
      if(position == 'right0') {
        $(this).find('.half-image-absolute').css('background-position', maxRight+'px center');
      }
      if(position == 'right25') {
        $(this).find('.half-image-absolute').css('background-position', (Math.floor(maxRight/4)*3)+'px center');
      }
    } else {

      var maxRight = Math.floor(halfWindow - calculatedImageWidth);


      if(position == 'left0') {
        $(this).find('.half-image-absolute').css('background-position', halfWindow+'px center');
      }
      if(position == 'left25') {
        $(this).find('.half-image-absolute').css('background-position', (Math.floor(maxRight/4)+halfWindow)+'px center');
      }
      if(position == 'center') {
        $(this).find('.half-image-absolute').css('background-position', (Math.floor(maxRight/2)+halfWindow)+'px center');
      }
      if(position == 'right0') {
        $(this).find('.half-image-absolute').css('background-position', (maxRight+halfWindow)+'px center');
      }
      if(position == 'right25') {
        $(this).find('.half-image-absolute').css('background-position', ((Math.floor(maxRight/4)*3)+halfWindow)+'px ');
      }

    }

  });
});

// landing page
$(document).ready(function() {
  $('.half-image-section.landing-page-half-image').each(function() {
    var position = $(this).data('position');
    var order = $(this).data('order');

    var winHeight = $(window).height();

    var calculatedImageWidth = 4 * winHeight / 3;

    var halfWindow = $(window).width() / 2;

    var maxRight = Math.floor(halfWindow - calculatedImageWidth);


    var quarterWindow = $(window).width() / 4;
    var eighthWindow = $(window).width() / 8;
    var sixteenWindow = $(window).width() / 16;
    var thirtyWindow = $(window).width() / 32;

    if(order == 1) {
      if(position == 'left25') {
        $(this).find('.half-image-absolute').css('background-position', Math.floor(maxRight/4)+'px center');
      }
      if(position == 'center') {
        $(this).find('.half-image-absolute').css('background-position', Math.floor(maxRight/2)+'px center');
      }
      if(position == 'right25') {
        $(this).find('.half-image-absolute').css('background-position', (Math.floor(maxRight/4)*3)+'px center');
      }
    } else {

      var maxRight = Math.floor(halfWindow - calculatedImageWidth);

      if(position == 'left25') {
        $(this).find('.half-image-absolute').css('background-position', (Math.floor(maxRight/4)+halfWindow)+'px center');
      }
      if(position == 'center') {
        $(this).find('.half-image-absolute').css('background-position', (Math.floor(maxRight/2)+halfWindow)+'px center');
      }
      if(position == 'right25') {
        $(this).find('.half-image-absolute').css('background-position', ((Math.floor(maxRight/4)*3)+halfWindow)+'px ');
      }
    }
  });

  if (!window.customElements.get("press-logo-marquee")) {
    window.customElements.define("press-logo-marquee", PressLogoMarquee );
  }
});


class PressLogoMarquee extends HTMLElement {
  constructor(){
    super();
    this.asdf = this.querySelector('.press-logo-wrapper');
  }

  animateMarquee() {
    function animate(){
      requestAnimationFrame(animationLoop);
    }

    const leftSideOfContainer = this.getBoundingClientRect().left;
    const itemsWrapperElem = this.querySelector('.press-logo-marquee-container');

    let currentLeftValue = 0;


    function animationLoop() {
      const firstListItem = itemsWrapperElem.querySelector('.logo-image:first-child');

      let rightSideOfFirstItem = firstListItem.getBoundingClientRect().right;

      if (rightSideOfFirstItem == leftSideOfContainer) {
        currentLeftValue = 20;
        itemsWrapperElem.appendChild(firstListItem);
      }

      itemsWrapperElem.style.marginLeft = `${currentLeftValue}px`;
      currentLeftValue--;
      animate();
    }
    animate();
  }

  connectedCallback() {
    this.animateMarquee();
  }
}